import { Components } from './styled';
import React from 'react';
import ProjectPicker from '../../../../../components/ProjectPicker';
import ProjectSearchDropdown from '../../../../../components/ProjectSearchDropdown';

const TableSearchBarComponent = ({
  pillarTypeProps,
  pillarExpertiseProps,
  categoryProps,
}: {
  pillarTypeProps: any;
  pillarExpertiseProps: any;
  categoryProps: any;
}) => {
  return (
    <Components.SearchBarChildrenWrapper>
      <Components.SearchBarSeparator />
      <Components.FiltersWrapper>
        <ProjectPicker dropdownProps={pillarTypeProps} notSetText={'Pillar type'} />
        <ProjectSearchDropdown {...pillarTypeProps} />
        <ProjectPicker dropdownProps={pillarExpertiseProps} notSetText={'Pillar expertise'} />
        <ProjectSearchDropdown {...pillarExpertiseProps} />
        <ProjectPicker dropdownProps={categoryProps} notSetText={'Category'} />
        <ProjectSearchDropdown {...categoryProps} />
      </Components.FiltersWrapper>
    </Components.SearchBarChildrenWrapper>
  );
};

export default TableSearchBarComponent;
